import {Injectable} from '@angular/core';
import {Http, RequestOptions, Headers, Response} from '@angular/http';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {environment} from '../../environments/environment';
import {NewPasswordModel} from './login.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export  class  AuthorizationService {

  private setNewPasswordURL = environment.apiUrl + '/User/SetNewPassword';
  private forgotPasswordURL = environment.apiUrl + '/User/ForgotPassword';

  constructor(private http: Http) {}

  private handleError (error: Response | any) {
    let errMsg: number;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body || JSON.stringify(body);
      errMsg = error.status;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  forgotPassword(email: string) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(this.forgotPasswordURL + '?email=' + email, options)
      .map((response) => response.status)
      .catch(this.handleError);
  }

  setNewPassword(newPasswordModel: NewPasswordModel) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    return this.http.put(this.setNewPasswordURL, newPasswordModel, options)
      .map((response: Response) => response)
      .catch(this.handleError);
  }





}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/authorization.service.ts